import { useImperativeHandle, useState } from 'react';
import Swal from 'sweetalert2'

function Search({ getDirecciones, setIsSearched, formRef }) {
    const [search, setSearch] = useState('')
    const [option, setOption] = useState('')

    useImperativeHandle(formRef, () => ({
            reset: () => {
                setOption('');
                setSearch('');
            }
        })
     );

    const showError = ({ message }) => {
        Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: message,
        })
    }
    const handleChangeOption = (e) => {
        setOption(e.target.value)

    }
    const handleChangeSearch = (e) => {
        setSearch(e.target.value)
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        switch (option) {
            case "":
                showError({ message: 'Seleccione una opción de búsqueda' })
                break;
            case "mailClient":
                if (!search) return showError({ message: "Escriba un Correo" });
                getDirecciones({ page: 1, [option]: search })
                setIsSearched({
                    option,
                    search,
                    state: true
                })
                break
            case "codCiudad":
                if (!search) return showError({ message: "Escriba un Código de Ciudad" });
                getDirecciones({ page: 1, [option]: search })
                setIsSearched({
                    option,
                    search,
                    state: true
                })
                break
            case "codDepartamento":
                if (!search) return showError({ message: "Escriba un Código de Departamento" });
                getDirecciones({ page: 1, [option]: search })
                setIsSearched({
                    option,
                    search,
                    state: true
                })
                break

            default:
                getDirecciones({})
                break
        }
    }
    return (
        <div>
            <div className="row mb-2">
                <h6>Busqueda de Direcciones</h6>
            </div>
            <div className="table-responsive rounded-3 d-flex justify-content-center" style={{ border: '1px solid black', padding: '15px' }}>
                <form className="row g-3">
                    <div className="col-auto">
                        <select onChange={handleChangeOption} className="form-select" aria-label="Default select example" value={option}>
                            <option value="">Seleccione</option>
                            <option value="mailClient">Correo Cliente</option>
                            <option value="codCiudad">Código de Ciudad</option>
                            <option value="codDepartamento">Código de Departamento</option>
                        </select>
                    </div>
                    <div className="col-auto">
                        <input type="text" className="form-control" id="search" name="search" onChange={handleChangeSearch} value={search} />
                    </div>
                    <div className="col-auto">
                        <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Buscar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Search
